import React, { useState } from "react";
import { modules } from "../routes.js";
import MenuCard from "./MenuCard";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes, faBars } from "@fortawesome/free-solid-svg-icons";

const Menu = () => {
  const [showMenu, setShowMenu] = useState(false);
  return (
    <>
      <div onClick={() => setShowMenu(true)} className="cursor-pointer">
        Módulos <FontAwesomeIcon icon={faBars} />

      </div>
      {showMenu ? (
        <div className="menu-modules shadow d-flex flex-column">
          <div className="d-flex">
            <h4>
              <strong>Módulos de aprendizaje Nuestro País</strong>
            </h4>
            <FontAwesomeIcon
              icon={faTimes}
              onClick={() => setShowMenu(false)}
              className="cursor-pointer close-menu"
            />
          </div>
          {modules.map((m, i) => (
            <div className="py-1" key={i}>
              {i === 0 ? (
                <p className="mb-2 mt-2">
                  <small className="text-muted">Primer grado</small>
                </p>
              ) : null}
              {i === 4 ? (
                <p className="mb-2 mt-2">
                  <small className="text-muted">Segundo grado</small>
                </p>
              ) : null}
              {i === 11 ? (
                <p className="mb-2 mt-2">
                  <small className="text-muted">Tercer grado</small>
                </p>
              ) : null}

              <MenuCard content={m} />
            </div>
          ))}
        </div>
      ) : null}
    </>
  );
};

export default Menu;
